import { Icon } from '@iconify/react';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import Hero3 from '../Hero/Hero3';
import PageHeading from '../PageHeading';
import Portfolio from '../Portfolio';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';


const heroSocialLinks = [
  {
    name: 'Instagram',
    links: 'https://www.instagram.com/justchargemedia/',
  },
  {
    name: 'Linkedin',
    links: 'https://www.linkedin.com/company/justchargemedia/posts/?feedView=all',
  },
];
const portfolioData = [
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/p1.png',
    category: 'crafting_brands',
  },
  {
    // title: 'Colorful Art Work',
    // // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/p2.png',
    category: 'crafting_brands',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/p3.png',
    category: 'crafting_brands',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/pb1.png',
    category: 'crafting_brands',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/p4.png',
    category: 'crafting_brands',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/p5.png',
    category: 'crafting_brands',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/pb2.png',
    category: 'crafting_brands',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/p6.png',
    category: 'crafting_brands',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/p7.png',
    category: 'crafting_brands',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/p8.png',
    category: 'crafting_brands',
  },
  // {
  //   // title: 'Colorful Art Work',
  //   // subtitle: 'See Details',
  //   // href: '/portfolio',
  //   src: '/images/p9.png',
  //   category: 'web_design',
  // },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/bt1.png',
    category: 'mobile_apps',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/bt2.png',
    category: 'mobile_apps',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/bt3.png',
    category: 'mobile_apps',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/bt4.png',
    category: 'mobile_apps',
  },
  // {
  //   // title: 'Colorful Art Work',
  //   // subtitle: 'See Details',
  //   // href: '/portfolio',
  //   src: '/images/bt5.png',
  //   category: 'mobile_apps',
  // },
  // {
  //   // title: 'Colorful Art Work',
  //   // subtitle: 'See Details',
  //   // href: '/portfolio',
  //   src: '/images/bt5.png',
  //   category: 'mobile_apps',
  // },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/bt5.png',
    category: 'mobile_apps',
  }, {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/de1.png',
    category: 'ui_ux_design',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/de2.png',
    category: 'ui_ux_design',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/de3.png',
    category: 'ui_ux_design',
  },

  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/de4.png',
    category: 'ui_ux_design',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/de5.png',
    category: 'ui_ux_design',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/de6.png',
    category: 'ui_ux_design',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/de7.png',
    category: 'ui_ux_design',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/de8.png',
    category: 'ui_ux_design',
  },
  {
    // title: 'Colorful Art Work',
    // subtitle: 'See Details',
    // href: '/portfolio',
    src: '/images/de9.png',
    category: 'ui_ux_design',
  },
  // {
  //   // title: 'Colorful Art Work',
  //   // subtitle: 'See Details',
  //   // href: '/portfolio',
  //   src: '/images/de10.png',
  //   category: 'ui_ux_design',
  // },
  // {
  //   // title: 'Colorful Art Work',
  //   // subtitle: 'See Details',
  //   // href: '/portfolio',
  //   src: '/images/de11.png',
  //   category: 'ui_ux_design',
  // },




];
const categoryMenu = [
  {


    title: 'Crafting Brands',
    category: 'crafting_brands',
  },
  {
    title: 'Designing Experiences',
    category: 'ui_ux_design',
  },
  {
    title: 'Building Tech',
    category: 'mobile_apps',
  },
  // {
  //   title: 'Creating Content',
  //   category: 'creating_content',
  // },
  // {
  //   title: 'Creators Conect',
  //   category: 'logo_design',
  // },

];

export default function PortfolioPage() {
  pageTitle('Portfolio');
  const [active, setActive] = useState('all');
  const [itemShow, setItemShow] = useState(7);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero3
        title="Creative <br />Portfolio"
        btnLink="contact"
        btnText={`Your Next Big Move Starts Here!`}
        socialLinksHeading="Follow Us"
        heroSocialLinks={heroSocialLinks}
        bgImageUrl="./images/hero_bg_4.jpeg"
      />
      <Spacing lg="145" md="80" />
      <Div className="container">
        <Div className="cs-portfolio_1_heading">
          <SectionHeading title="Explore Our Portfolio" subtitle="Our Latest Creations" />
          <Div className="cs-filter_menu cs-style1">
            <ul className="cs-mp0 cs-center">
              <li className={active === 'all' ? 'active' : ''}>
                <span onClick={() => setActive('all')}>All</span>
              </li>
              {categoryMenu.map((item, index) => (
                <li
                  className={active === item.category ? 'active' : ''}
                  key={index}
                >
                  <span onClick={() => setActive(item.category)}>
                    {item.title}
                  </span>
                </li>
              ))}
            </ul>
          </Div>
        </Div>
        <Spacing lg="90" md="45" />
        <Div className="row">
          {portfolioData.slice(0, itemShow).map((item, index) => (
            <Div
              className={`${index === 3 || index === 6 ? 'col-lg-8' : 'col-lg-4'
                } ${active === 'all'
                  ? ''
                  : !(active === item.category)
                    ? 'd-none'
                    : ''
                }`}
              key={index}
            >
              <Portfolio
                title={item.title}
                subtitle={item.subtitle}
                href={item.href}
                src={item.src}
                variant="cs-style1 cs-type1"
              />
              <Spacing lg="25" md="25" />
            </Div>
          ))}
        </Div>

        <Div className="text-center">
          {portfolioData.length <= itemShow ? (
            ''
          ) : (
            <>
              <Spacing lg="65" md="40" />
              <span
                className="cs-text_btn"
                onClick={() => setItemShow(itemShow + 3)}
              >
                <span>Load More</span>
                <Icon icon="bi:arrow-right" />
              </span>
            </>
          )}
        </Div>
      </Div>
      <Spacing lg="145" md="80" />
      <Cta
        title="magic@justcharge.in"
        bgSrc="/images/cta_bg_2.jpeg"
        variant="rounded-0"
      />
    </>
  );
}
